var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCryptoDpt = function SvgCryptoDpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.934 6.252H4.623v11.76a1 1 0 0 1-.077-.25L2.5 5.693 18.383 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.84h-4.415l-3.024.002.005-1.41-2.7 2.229 2.7 2.227-.006-1.413h3.025l-.001.002H21.5v5.809H8.39a3 3 0 0 1-3-3V7.019H21.5z"
  })));
};
export default SvgCryptoDpt;